// extracted by mini-css-extract-plugin
module.exports = {"collapsibleChildren":"_2sOwxevMAHiH-xyRBdMSny","expanded":"ZE6QRFZ2LeOQ-ST7NaugF"};